import { render, staticRenderFns } from "./ProfileBuild.vue?vue&type=template&id=ed5457ac&scoped=true"
import script from "./ProfileBuild.vue?vue&type=script&lang=ts"
export * from "./ProfileBuild.vue?vue&type=script&lang=ts"
import style0 from "./ProfileBuild.vue?vue&type=style&index=0&id=ed5457ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5457ac",
  null
  
)

export default component.exports